import filterDeep from 'deepdash-es/filterDeep';

const findAll = (tree, pred) => {
  return tree.reduce((a, item) => {
    if (pred(item)) {
      a.push(item);
    }

    if (item.children) {
      const items =  findAll(item.children, pred);
      items.forEach((item) => a.push(item));
    }

    return a;
  }, []);
};

const find = (tree, key, term, childrenPath = 'children') => {
  return tree.reduce((a, item) => {
    if (a) {
      return a;
    }
    if (item[key] === term) {
      return item;
    }
    if (item[childrenPath]) {
      return find(item[childrenPath], key, term);
    }
  }, null);
};

const set = (tree, key, term) => {
  tree.forEach((item) => {
    item[key] = term;

    if (item.children) {
      set(item.children, key, term);
    }
  });
};

const remove = (tree, key, term) => {
  tree.forEach((item, index) => {
    if (item[key] === term) {
      tree.splice(index, 1);

      return;
    }

    if (item.children) {
      remove(item.children, key, term);
    }
  });
};

const reorderTopics = (tree, element) => {
  return tree.map((item) => {
    if (item.id === element.parentTopicId) {
      item.children.forEach((children, indexChildren) => {
        children.sequence = indexChildren + 1;
      });

      return;
    }

    if (item.children) {
      reorderTopics(item.children, element);
    }
  });
};

const changeOrder = (tree, element, oldIndex, newIndex, layout) => {
  return tree.map((item) => {
    if (item.id === element.parentTopicId) {
      item.children.splice(newIndex, 0, item.children.splice(oldIndex, 1)[0]);

      item.children.forEach((children, indexChildren) => {
        children.sequence = indexChildren + 1;
      });

      item.layout = layout || item.layout;

      return;
    }

    if (item.children) {
      changeOrder(item.children, element, oldIndex, newIndex, layout);
    }
  });
};

const getParentOfSelectedTopic = (topics, selectedTopic) => {
  let parent = {};

  topics.map(itemFirstLevel => {
    if (itemFirstLevel.id === selectedTopic.parentTopicId) {
      parent = itemFirstLevel;
    }

    if (itemFirstLevel.children) {
      itemFirstLevel.children.map(itemSecondLevel => {
        if (itemSecondLevel.id === selectedTopic.parentTopicId) {
          parent = itemSecondLevel;
        }

        if (itemSecondLevel.children) {
          itemSecondLevel.children.map(itemThirdLevel => {
            if (itemThirdLevel.id === selectedTopic.parentTopicId) {
              parent = itemThirdLevel;
            }

            if (itemThirdLevel.children) {
              itemThirdLevel.children.map(itemFourthLevel => {
                if (itemFourthLevel.id === selectedTopic.parentTopicId) {
                  parent = itemFourthLevel;
                }
              });
            }
          });
        }
      });
    }
  });

  return parent;
};

const filterKeepingStructure = (data, predicate, childrenPath = 'children') => filterDeep(data, predicate, { childrenPath, onTrue: { skipChildren: true } }) || [];

const shouldExpandAAutocompleteItem = (node, selectedId) => {
  const shouldExpand = (node.children || []).some(child => {
    if (Array.isArray(child.children) && child.children.length) {
      return shouldExpandAAutocompleteItem(child, selectedId);
    }

    return child.id === selectedId;
  });

  return shouldExpand;
};

const expandAAutocompleteNodeBySelectedItem = (componentRef, selectedId) => {
  componentRef.traverseAllNodesByIndex(node => {
    if (node.isBranch) {
      const shouldExpand = shouldExpandAAutocompleteItem(node, selectedId);

      node.isExpanded = shouldExpand || node.isExpanded;
    }
  });
};

export {
  findAll,
  find,
  set,
  remove,
  changeOrder,
  reorderTopics,
  getParentOfSelectedTopic,
  filterKeepingStructure,
  expandAAutocompleteNodeBySelectedItem
};
